import { ABOUTUSCONTENT_GET_LIST,ABOUTUSCONTENT_GET_LIST_SUCCESS,ABOUTUSCONTENT_GET_LIST_ERROR } from "../../../redux/contants";

const INIT_STATE = {
    getAboutUsContentList: [],
    loading: false,
    error: '',
    messages: ''
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ABOUTUSCONTENT_GET_LIST:
            // alert(action.type)
            // alert(action.data)
            return { ...state, loading: true, error: '' };
        
        case ABOUTUSCONTENT_GET_LIST_SUCCESS:
            console.log('ABOUTUSCONTENT_GET_LIST_SUCCESS===',action);
            return {
                ...state,
                loading: false,
                getAboutUsContentList: action.data,
                error: '',
                messages: ''
            };
        case ABOUTUSCONTENT_GET_LIST_ERROR:
            return {
                ...state,
                loading: false,
                getAboutUsContentList: [],
                error: action.error,
                messages: ''
            };
        
        default:
            return { ...state };
    }
};
